import { Component, OnInit } from '@angular/core';
import {BrowserStorageService} from '../../services/browser-storage.service';

@Component({
  standalone: false,
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit {

  showCookiesTermsDialog = true;
  private readonly storageKey = 'cookiesTermsAccepted';

  constructor(
    private storageService: BrowserStorageService,
  ) { }

  ngOnInit() {
    this.checkAcceptedCookiesTerm();
  }

  private checkAcceptedCookiesTerm() {
    const accepted = this.storageService.getLocal(this.storageKey);
    if (accepted === true) {
      this.showCookiesTermsDialog = false;
    }
  }

  acceptCookiesAndTerms() {
    this.storageService.setLocal(this.storageKey, true);
    this.showCookiesTermsDialog = false;
    console.log('Cookies & Terms accepted');
  }
}
